// removed by extract-text-webpack-plugin
module.exports = {"canvas":"canvas__1A9rB"};


//////////////////
// WEBPACK FOOTER
// ./components/RomanceBreakdownViz/Images/style.css
// module id = cdmB
// module chunks = 0